import { createContext, useContext } from 'react';

import type { FlagEntityTypeEnum } from '@/features/flag/types/flagEntityType';

export type FlagContextValues = {
  flag: (entityType: FlagEntityTypeEnum, id: string) => void;
};

const defaultContextValues: FlagContextValues = {
  flag: () => {}
};

export const FlagContext =
  createContext<FlagContextValues>(defaultContextValues);
export const useFlag = () => useContext(FlagContext);
